import { z } from 'zod'

export enum SupportFromField {
  Nickname = 'nickname',
  Uid = 'uid',
  Email = 'email',
  Telephone = 'telephoneNumber',
  GameType = 'gameType',
  Brief = 'brief',
}

export const SupportSchema = z.object({
  [SupportFromField.Nickname]: z.string().optional(),
  [SupportFromField.Uid]: z.string().optional(),
  [SupportFromField.Email]: z.string().nonempty(),
  [SupportFromField.Telephone]: z.string().optional(),
  [SupportFromField.GameType]: z.string().nonempty(),
  [SupportFromField.Brief]: z.string().nonempty(),
})

export const SupportFormProps = new Map([
  [SupportFromField.Nickname, { label: 'Game Nickname' }],
  [SupportFromField.Uid, { label: 'UID' }],
  [SupportFromField.Email, { label: 'Email', required: true }],
  [SupportFromField.Telephone, { label: 'Telephone Number' }],
  [SupportFromField.GameType, { label: 'Select Game', required: true }],
  [SupportFromField.Brief, { label: 'Please briefly state the problem encountered', required: true }],
])
